import React from "react";
import { BadgePercent } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { useIsAndroidApp } from "@/hooks/useLaunchContext";

// Cache module : un seul fetch de /promo/active pour tous les badges de la page.
let promoPromise = null;
function fetchPromo() {
  if (!promoPromise) {
    promoPromise = api.get("/promo/active").then((r) => r.data).catch(() => null);
  }
  return promoPromise;
}

// Badge promo saisonnier (ex: WINTER2026 -70%) - UNIQUEMENT web : jamais dans l'app Android
// (aucune notion de prix côté app, Google Play gère). Entièrement dynamique via /api/promo/active.
export function PromoBadge({ variant = "hero" }) {
  const { language } = useI18n();
  const isTwaApp = useIsAndroidApp();
  const [promo, setPromo] = React.useState(null);
  React.useEffect(() => {
    if (isTwaApp) return;
    let on = true;
    fetchPromo().then((p) => { if (on && p?.code && p?.percent_off) setPromo(p); });
    return () => { on = false; };
  }, [isTwaApp]);
  if (isTwaApp || !promo) return null;
  const isEn = language === "en";
  const label = isEn
    ? `-${promo.percent_off}% with code ${promo.code}`
    : `-${promo.percent_off}% avec le code ${promo.code}`;
  const sub = isEn ? "on your first order" : "sur votre 1ʳᵉ commande";
  if (variant === "card") {
    return (
      <span
        data-testid="promo-badge-card"
        className="relative mx-auto mt-3 inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-primary to-fuchsia-600 px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-white shadow-lg shadow-primary/30"
      >
        <BadgePercent className="h-3.5 w-3.5" />
        {label}
      </span>
    );
  }
  return (
    <div
      data-testid="promo-badge-hero"
      className="mt-4 inline-flex animate-pulse items-center gap-2 rounded-full border border-fuchsia-400/40 bg-gradient-to-r from-primary to-fuchsia-600 px-5 py-2 text-sm font-bold text-white shadow-[0_0_30px_-8px_hsl(var(--primary))]"
    >
      <BadgePercent className="h-4 w-4" />
      <span>{label}</span>
      <span className="hidden font-medium opacity-90 sm:inline">· {sub}</span>
    </div>
  );
}
